module.exports = __webpack_public_path__ + "static/media/icon-pmv.c8bc7728.svg";